<fin-skip-link [main]="main" />
<fin-schema />
<fin-cms-global-disruption-banner />

<router-outlet name="campaign-banner" />
<router-outlet name="header" />

<fcom-notification
  *ngIf="showIndiaRedirectNotification"
  [isClosable]="true"
  (closeClick)="onCloseIndiaNotification()"
  >{{ 'indiaRedirectNotification' | finLocalization }}</fcom-notification
>

<main #main [class.layout--footer-open]="isFooterOpen$ | async" role="main">
  <router-outlet />
</main>

<footer>
  <router-outlet name="footer" />
</footer>
